import React from "react";

const FAQ = () => {
  const FAQData = [
    {
      title: "Popular cuisines near me",
      lItems1: "Bakery Food near me",
      lItems2: "Beverages Food near me",
      lItems3: "Biryani food near me",
      lItems4: "Burger Food near me",
      lItems5: "Cafe Items near me",
    },
    {
      title: "Popular restaurant types near me",
      lItems1: "Bakeries Near Me",
    },
    {
      title: "Cities We Deliver To",
      lItems1: "Delhi NCR",
    },
  ];
  return (
    <div className="text-center">
      <div className="m-5 mobileClassMarginFAQ">
        {FAQData.map((data) => {
          return (
            <details className="deatilTag m-auto mt-4 p-4 text-start border rounded mobileClassFAQ">
              <summary>{data.title}</summary>
              <ul className="d-flex flex-wrap">
                <li
                  className="text-secondary fw-normal mt-3"
                  style={{ fontSize: "14px" }}
                >
                  {data.lItems1}
                </li>

                <li
                  className="text-secondary fw-normal mt-3"
                  style={{ fontSize: "14px" }}
                >
                  {data.lItems2}
                </li>

                <li
                  className="text-secondary fw-normal mt-3"
                  style={{ fontSize: "14px" }}
                >
                  {data.lItems3}
                </li>

                <li
                  className="text-secondary fw-normal mt-3"
                  style={{ fontSize: "14px" }}
                >
                  {data.lItems4}
                </li>

                <li
                  className="text-secondary fw-normal mt-3"
                  style={{ fontSize: "14px" }}
                >
                  {data.lItems5}
                </li>
              </ul>
            </details>
          );
        })}
      </div>
    </div>
  );
};

export default FAQ;
